import { Layout } from 'react-admin';
import React from 'react';
import AppBar from './AppBar';
import { Box } from '@mui/material';

const CustomLayout = (props) => (
    <Box
        sx={{
            position: 'relative',
            minHeight: '100vh',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: 'url(/wygc-bg.svg)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                opacity: 0.05, // Subtle background
                pointerEvents: 'none', 
                zIndex: -1,
            },
        }}
    >
        <Layout
            {...props}
            appBar={AppBar}
        />
    </Box>
);

export default CustomLayout;
